/*
 *
 * OperationDCC
 *
 * @version 1.0.0
 * @author Christopher Monti
 * @since 10-Mar-2025
 */

import React from 'react'
import PropTypes from 'prop-types'
import { formatFiscalAmount } from 'Utility/numberMethods'
import PortalTextBlocked from 'Components/PortalTextBlocked'
import formattedMessage from './languageModule'
import './OperationDCC.scss'

const OperationDCC = ({ info, isLoading }) => {
  const fields = {
    transactionDCCId: info?.transactiondccid || '-',
    rrID: info?.rrid || '-',
    merchantAmount: (info?.merchantamount &&
      info?.merchantcurrency &&
      formatFiscalAmount(info?.merchantamount, info?.merchantcurrency, false)) ||
    '-',
    merchantCurrency: info?.merchantcurrency || '-',
    merchantCurrencyCode: info?.merchantcurrencycode || '-',
    operationAmount: (info?.cardholderamount &&
      info?.cardholdercurrency &&
      formatFiscalAmount(info?.cardholderamount, info?.cardholdercurrency, false)) ||
    '-',
    operationCurrency: info?.cardholdercurrency || '-',
    cardholderCurrencyCode: info?.cardholdercurrencycode || '-',
    conversionRate: info?.conversionrate ? formatFiscalAmount(
      info?.conversionrate,
      info?.cardholdercurrency,
      false,
      4,
      { scale: false, roundingMode: 'trunc' }) : '-',
    markup: info?.markup || '-',
    markupIncludesECB: info?.markupincludesecb || '-',
    outcome: info?.outcome || '-'
  }

  return (
    <div className='text_field_section'>
      {fields &&
        Object.entries(fields).map(([field, value]) => (
          <PortalTextBlocked
            key={`operation-dcc-field-${field}`}
            label={formattedMessage[field]}
            value={value || '-'}
            isLoading={isLoading}
            noPadding
          />
        ))}
    </div>
  )
}

OperationDCC.propTypes = {
  // Add here some propTypes
  // and set a minimal description i.e.
  /** Description of prop "baz". */
  info: PropTypes.object,
  isLoading: PropTypes.bool
}

OperationDCC.defaultProps = {
  // Add here some default propTypes values
  info: {},
  isLoading: false
}

export default OperationDCC
